import { ModalModel } from '@notino/react-styleguide-v20';

const MODAL_SETTINGS_SHARED = {
  centerVertically: true,
  showOverflow: false,
  breakpoint: ModalModel.Breakpoints.lg,
};

export const MODAL_SETTINGS_LARGE = {
  ...MODAL_SETTINGS_SHARED,
  size: ModalModel.Sizes.large,
};

export const MODAL_SETTINGS_DEFAULT = {
  ...MODAL_SETTINGS_SHARED,
  size: ModalModel.Sizes.default,
};
